import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import ImageArt from './imageart';
import { RowDivision, DivisionLabel, HelperText } from '../shared/styled-components';

const CoverArt = (props) => {
  const {
    label,
    helper,
    required,
    ...remainingProps
  } = props;

  const requiredRender = (required) ? (
    <span style={styles.inputLabelRequire}>*</span>
  ) : null;

  const helperRender = (!isEmpty(helper)) ? (
    <HelperText>
      {helper}
    </HelperText>
  ) : null;

  return (
    <RowDivision className="row">
      <div id="covert-art" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <DivisionLabel>
          {label} {requiredRender}
          {helperRender}
        </DivisionLabel>
        <ImageArt
          {...remainingProps}
          artStyle={{
            wrapper: styles.coverArtUploader,
            cover: styles.coverArt,
            button: styles.uploadResourceButton,
          }}
        />
      </div>
    </RowDivision>
  );
};

CoverArt.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  helper: PropTypes.string,
  ...ImageArt.propTypes,
};

CoverArt.defaultProps = {
  label: 'Cover Art',
  required: false,
  helper: '(Required: square image between 1400 x 1400 pixels and 3000 x 3000 pixels, in .jpeg or .png format)',
  ...ImageArt.defaultProps,
};

export default CoverArt;
